import React, { useState } from "react";
import apiClient from "../../../services/apiClient";
import { useNavigate } from "react-router-dom";

import "../../../stylesheets/dashboard.css";
import template1 from "./template1.png";
import template2 from "./template2.png";
import template3 from "./template3.png";
import template4 from "./template4.png";
import "./ResumeTemplates.css";
import ProcessingLoader from "../ProcessingLoader";
import { useUserContext } from "../../common/UserProvider";
import { useResume } from "../ResumeContext";
import Overlay from "./Overlay";
import JobDescriptionModal from "./JobDescriptionModel";
import resumeBackButton from "./resume-back-button.png";
import { useEffect } from "react";

const ResumeTemplates = () => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState({});
  const { resumeState, updateResumeState } = useResume();
 const { user } = useUserContext();
 const[showJD, setShowJD] = useState(false);
const applicantId = user?.id;
  const navigate = useNavigate();

  const handleImageLoad = (templateId) => {
    setImagesLoaded(prev => ({
      ...prev,
      [templateId]: true
    }));
  };

  const handleGenerate = async (e) => {
    e.stopPropagation();

    if (!selectedTemplate) {
      alert("Please select a template");
      return;
    }

    try {
      // open loader
      setIsOpen(true);

      const response = await apiClient.post(
  "/api/resume/download/resume",
  {
    applicantId: applicantId,
    resumeVersion: selectedTemplate,
    jd: resumeState.jobDescription || "",
  },
  {
    responseType: "blob",
    headers: {
      Accept: "application/pdf", // 👈 IMPORTANT
    },
  }
);

      
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = window.URL.createObjectURL(file);
      updateResumeState("pdfUrl", fileURL);
updateResumeState("templateId", selectedTemplate);



      
      setIsOpen(false);

     
      navigate("/resume-preview", {
        state: { pdfUrl: fileURL },
       
      });

    } catch (error) {
      console.error("Generate resume failed:", error);

      setIsOpen(false);

      alert("Failed to generate resume. Please try again.");
    }
  };

  useEffect(() => {
    console.log("Resume state in templates:", resumeState);
  }, []);

  return (
    <div className="border-style">
      <div className="blur-border-style"></div>

      <div className="dashboard__content resume-template">
        <div className="resume-template-header">
        <img src={resumeBackButton} alt="Back" onClick={() => setShowJD(true)} />
        <h2 className="title">Select ATS Resume Template</h2>
        </div>

        <div className="resume-wrapper">
          
          <div className="template-container">
            {[1, 2, 3, 4].map((id) => (
              <div
                key={id}
                className={`template-card ${selectedTemplate === id ? "active" : ""} ${imagesLoaded[id] ? "loaded" : "loading"}`}
                onClick={() => setSelectedTemplate(id)}
              >
                {!imagesLoaded[id] && <div className="template-skeleton"></div>}
                <img 
                  src={id === 1 ? template1 : id === 2 ? template2 : id === 3 ? template3 : template4} 
                  alt={`template${id}`} 
                  onLoad={() => handleImageLoad(id)}
                />
                <p><b>
                  {id === 1 && "Professional Classic"}
                  {id === 2 && "Modern Executive"}
                  {id === 3 && "Creative Designer"}
                  {id === 4 && "Technical Developer"}
                </b></p>

                {selectedTemplate === id && (
                  <button onClick={handleGenerate}>
                    Generate Now
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* loader */}
      {isOpen && <ProcessingLoader isOpen={isOpen} />}
       {showJD && (
  <Overlay onClose={() => setShowJD(false)}>
    <JobDescriptionModal 
       onClose={() => setShowJD(false)}
       onFinish={(jobText) => {
          // 1. Store the JD (will be "" if they skip)
          updateResumeState('jobDescription', jobText);
          
          
          // 2. Close the modal
          setShowJD(false);
          
          // 3. Navigate to the Templates page     
          navigate('/resume-templates');
       }}
    />
  </Overlay>
)}
    </div>
  );
 
};

export default ResumeTemplates;
